<div class="page">
  <re-login-content
    class="content"
    [onLoginSubmit]="onLoginSubmit"
    [message]="message"
    [qaBuild]="qaBuild"
  />
  <re-login-footer
    class="footer"
    [version]="version"
    [buildDate]="buildDate"
    [baseUrl]="baseUrl"
    [qaBuild]="qaBuild"
  />
</div>
